import styled from "styled-components";

const CardsWrapperQA = styled.div``;
export default CardsWrapperQA;
